import useConfig from "@/composables/config";

const { config } = useConfig();

export default function useLocale() {
  async function setSessionLocale(locale: string) {
    await fetch(`${config.apiPath}/setSessionLocale?lang=${locale}`);
  }

  return {
    setSessionLocale,
  };
}
